<div class="ai-reports reports-dialog pl-0">
  @if (consentAccepted()) {
    <div class="tab-container px-0 pb-0">
      <div class="tabs ml-0 mt-2 border-bottom-0">
        <a id="ai-tab-templates" [class.active]="viewMode() == ViewAIReportMode.Templates" (click)="changeViewMode(ViewAIReportMode.Templates)"
           (keydown.enter)="changeViewMode(ViewAIReportMode.Templates)"
           tabindex="0">{{ "aiReport.lbl_template" | translate }}</a>
        <a id="ai-tab-history" [class.active]="viewMode() == ViewAIReportMode.History" (click)="changeViewMode(ViewAIReportMode.History)"
           (keydown.enter)="changeViewMode(ViewAIReportMode.History)"
           tabindex="0">{{ ("aiReport.lbl_history" | translate) }}</a>
        <a id="ai-tab-chat" [class.active]="viewMode() == ViewAIReportMode.Chat" (click)="changeViewMode(ViewAIReportMode.Chat)"
           (keydown.enter)="changeViewMode(ViewAIReportMode.Chat)"
           tabindex="0">{{ ("aiReport.lbl_chat" | translate) }}</a>
      </div>
      <!-- Always mounted (rather than gated behind an @if) so its balance SSE subscription stays
           alive across tab switches instead of being torn down/reopened on every Chat re-entry —
           a mid-stream deduction while the user is on another tab would otherwise be silently
           missed. Hidden via CSS instead of being removed from the DOM. -->
      <app-credits-bar [class.d-none]="viewMode() !== ViewAIReportMode.Chat" />
      <div class="tab-forms app-light-bg">
        @switch (viewMode()) {
          @case (ViewAIReportMode.Templates) {
            <app-templates (templateSelected)="switchToChat($event)"></app-templates>
          }
          @case (ViewAIReportMode.Chat) {
            <app-chat [initialPrompt]="selectedPrompt()"></app-chat>
          }
          @case (ViewAIReportMode.History) {
            <app-history (threadSelected)="switchToChat()"></app-history>
          }
        }
      </div>
    </div>
  } @else {
    <app-consent-gate />
  }
</div>
